
    /**
    * 员工查询
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * OfficalEmployeeQueryParam :OfficalEmployeeQueryParam
 */
export class IReqApiEmployeeQuery28875 {
  /**
   * 查询关键字,手机号花名真名
   */
  key: {};
  /**
   * 临时令牌(短信登陆后获得)
   */
  tmpToken: {};
}
    /**
 * YResult<OfficalEmployeeInfoResp> :YResult
 */
export class IResApiEmployeeQuery28875 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * OfficalEmployeeInfoResp
   */
  data?: {
    /**
     * 员工信息列表 ,OfficalEmployeeInfo
     */
    employeeInfoList?: {
      /**
       * 花名
       */
      nickName?: {};
      /**
       * 真名
       */
      realName?: {};
      /**
       * 手机号
       */
      mobile?: {};
      /**
       * 职位
       */
      position?: {};
      /**
       * 是否离职
       */
      isLeave?: {};
      /**
       * 头像url
       */
      iconUrl?: {};
    }[];
    /**
     * 查无此人,默认提示
     */
    defaultMsg?: string;
  };
  exceptionMsg?: {};
}
    const http: Serve<IReqApiEmployeeQuery28875, IResApiEmployeeQuery28875> = (data?) =>  request({
      method: 'POST',
      url: '/api/employee/query',
      data:data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    }) 
    export default http